module.exports = __webpack_public_path__ + "vrbo-logo.png?e256ec5e6e938aa36c88e3c1427602a8";